import { createSlice } from "@reduxjs/toolkit";

const gallerySlice = createSlice({
    name: 'gallery',
    initialState: {
        array: null,
        indexShowed: 0,
        activityId: null
    },
    reducers: {
        setGallery: (state, action) => {
            const { array, firstShowed, activityId } = action.payload;
            state.array = array;
            state.indexShowed = firstShowed;
            state.activityId = activityId;
        },
        emptyGallery: (state) => {
            state.array = null;
            state.indexShowed = 0;
            state.activityId = null;
        },
        changeIndex: (state, action) => {
            state.indexShowed = action.payload
        }
    }
})

export const { setGallery, emptyGallery, changeIndex } = gallerySlice.actions;
export default gallerySlice.reducer